module.exports = __webpack_public_path__ + "img/qualificacao-10.b8538733.png";